import { Cart, MainProduct } from "../../../types"
import { getEditModeItems, getMainProductVariantById, getPendantProductByPendantProductVariantId, getPendantProductVariantById, getSinglePendantMainProductVariant } from "../../../utils"

export type BuilderLineItem = {
  id: string;
  quantity: number;
  properties: Record<string, string | number>;
}

const getOnlinePendantsPropertyValue = (
  mainProduct: MainProduct, 
  pendantProductVaraintIds: string[]
) => {
  const onlinePendantsPropertyValue = pendantProductVaraintIds
    .map((pendantProductVaraintId, index) => {
      const pendantProduct = getPendantProductByPendantProductVariantId(mainProduct, pendantProductVaraintId)
      const pendantProductVaraint = getPendantProductVariantById(mainProduct, pendantProductVaraintId)

      const label = `\n ${index + 1}. ${pendantProduct.title} (${pendantProductVaraint.title})`.toUpperCase()

      return label
    })
    .join(", ")

  return onlinePendantsPropertyValue
}

export const getLineItems = (
  mainProduct: MainProduct, 
  activeMainProductVariantId: string, 
  activePendantProductVariantIds: string[],
  quantity: number,
  bundleUrl: string,
  isMainProductSinglePendant: boolean
): BuilderLineItem[] => {
  const _uniqueTimeStamp = String(Date.now())

  const necklaceProperties = {
    _uniqueTimeStamp,
    _uuid: crypto.randomUUID(),
    _2d_builder: 1,
    _spiffTransactionId: 1,
    _url: bundleUrl
  }

  if (isMainProductSinglePendant) {
    const variantToAdd = getSinglePendantMainProductVariant(mainProduct, +activeMainProductVariantId, +activePendantProductVariantIds[0])
 
    return [
      {
        id: String(variantToAdd.id), 
        quantity,
        properties: necklaceProperties
      }
    ]
  } 

  const lineItems = [
    {
      id: activeMainProductVariantId, 
      quantity,
      properties: {
        ['Online - Pendants']: getOnlinePendantsPropertyValue(mainProduct, activePendantProductVariantIds),
        ['Bespoke Item']: 'Cannot be returned for change of mind',
        ...(mainProduct.tags.includes('Production Type_Bespoke') ? {
          ['Bespoke Item']: 'Cannot be returned for change of mind'
        } : {}),
        ...necklaceProperties
      }
    },
    ...activePendantProductVariantIds
      .map(activePendantProductVariantId => {
        return ({
          id: activePendantProductVariantId,
          quantity: 1,
          properties: {
            _NecklaceId: activeMainProductVariantId,
            Necklace: getMainProductVariantById(mainProduct, activeMainProductVariantId).title,
            _uniqueTimeStamp,
            _uuid: crypto.randomUUID(),
            _2d_builder: 1,
          }
        })
      })
  ]

  return lineItems
}

export const getEditModeLineItems = (mainProduct: MainProduct, cart: Cart) => {
  const editModeItems = getEditModeItems(mainProduct, cart)

  if (!editModeItems) return null

  return ({
    [editModeItems.chain.key]: 0,
    ...editModeItems.pendants.reduce((result, pendantItem) => ({
      ...result, [pendantItem.key]: 0
    }), {})
  })
}

export const getEditModeItemsQuantity = () => {
  const urlSearchParams = new URLSearchParams(window.location.search)
  const quantity = urlSearchParams.get('edit_q') || 1
  return Number(quantity)
}

export const stopEditingMode = () => {
  const url = new URL(window.location.href)
  const urlSearchParams = url.searchParams

  urlSearchParams.delete('edit_qts')
  urlSearchParams.delete('edit_q')

  window.history.replaceState({}, '', url.toString())
}